<template>
  <section class="overview">
    <v-container>
      <h1 class="header-title optus-highlight optus-highlight--yellow">
        My Dashboard&nbsp;
      </h1>
      <overview-card
        v-if="dashboard"
        class="mt-3"
        :registered-teachers="dashboard.teachers_count"
        :active-classes="dashboard.custom_classes_count"
        :active-students="dashboard.students_count"
      />
      <v-row>
        <v-col class="chart" sm12>
          <login-registration-chart />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="chart" sm12>
          <registration-data-table />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import LoginRegistrationChart from './login_registration/LoginRegistrationChart'
import StateDataTable from './school_state/StateDataTable'
import StateChart from './school_state/StateChart'
import SectorChart from './school_sector/SectorChart'
import SectorDataTable from './school_sector/SectorDataTable'
import GenderDataTable from './school_gender/GenderDataTable'
import GenderChart from './school_gender/GenderChart'
import ModuleDataTable from './modules/ModuleDataTable'
import RegistrationDataTable from './registration/RegistrationDataTable'
import Auth from '@/modules/auth/models/Auth'
import { mapState } from 'vuex'
import OverviewCard from '@/modules/auth/views/dashboard/OverviewCard'

export default {
  name: 'Overview',
  components: {
    LoginRegistrationChart,
    StateDataTable,
    StateChart,
    SectorChart,
    SectorDataTable,
    GenderDataTable,
    GenderChart,
    ModuleDataTable,
    OverviewCard,
    RegistrationDataTable
  },
  data() {
    return {
      dashboard: null
    }
  },
  computed: {
    ...mapState(['bucketUrl']),
    options() {
      return {}
    },
    me() {
      return Auth.query()
        .where('type', 'client')
        .first()
    }
  },
  async created() {
    this.dashboard = await this.$axios.get(
      'api/clients/reports?type=dashboard&date_start=2010-01-01&date_end=2030-01-01'
    )
  }
}
</script>

<style lang="scss">
.chart {
  margin-top: 30px;

  th,
  td {
    font-size: 14px !important;
  }

  button.v-pagination__navigation {
    display: none !important;
  }
}

.chart-title {
  background-color: var(--v-primary-base) !important;
  color: #ffffff !important;
  font-size: 16px;
}

.graphSelect {
  font-size: 14px !important;
  width: 50%;
}
</style>
